module.exports = __webpack_public_path__ + "static/media/ljubljana-4.acc3f480.jpg";